var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data)?_c('Transition',{attrs:{"appear":""}},[_c('section',{staticClass:"section-pageHeader"},[(_vm.data.Image)?_c('v-img',{staticStyle:{"height":"180px"},attrs:{"src":_vm.$store.state.url + _vm.data.Image.fullpath,"alt":_vm.data.Image.metadata
          ? _vm.data.Image.metadata[0].data
          : _vm.data.Image.filename}}):_vm._e()],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }